module.exports = __webpack_public_path__ + "media/images/partners/region-service-241f6085095cda8b2abe937d6f7ed976.png";